/**
 * Build-time snapshot injected by scripts/prerender-seo-pages.js.
 * The inline script runs before the bundle, so the first client render
 * matches the HTML ReactDOMServer wrote and hydrateRoot does not replace it.
 */
export function readPrerenderState() {
  if (typeof window === 'undefined') return null;
  const data = window.__FIXOME_PRERENDER__;
  return data && typeof data === 'object' ? data : null;
}
